
const Slash = () => {
    const slashArray = [];
    for (let i = 0; i < 25; i++) {
        slashArray.push("|")
    }
    return (
        <>

            <ul>
                {
                    slashArray.map((slash, index) => {
                        return <li key={index} >{slash}</li>
                    })
                }
            </ul>

        </>
    )
}

export default Slash